import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found — Sutranode";
  }, []);

  return (
    <section className="notfound-section">
      <div className="notfound-inner">
        <div className="notfound-code">404</div>
        <h1 className="notfound-title">This thread doesn't lead anywhere.</h1>
        <p className="notfound-body">
          The page you're looking for doesn't exist, or has moved. Let's get you back to something
          useful.
        </p>
        <div className="notfound-actions">
          <Link to="/" className="btn-gold">Back to home →</Link>
          <Link to="/work" className="btn-ghost">See the work</Link>
        </div>
      </div>
    </section>
  );
}
